export * from './backend';
export * from './contract';

export type Lootbox = {
	id: string;
	title: string;
	price: number;
	listed: number;
	totalSupply: number;
	available: number;
};

export type PurchasedLootbox = {
	id: string;
	lootboxId: number;
	data: Lootbox;
};

export type Lootboxes = {
	id: string;
	lootboxes: Lootbox[];
};

export type NftSpec = {
	id: string;
	name: string;
	description: string;
	customDescription: string | undefined;
	secondaryMarketUrl?: string;
	url: string;
	supply: number;
	available: number;
	price: number;
};

export type NftFactory = {
	id: string;
	specs: NftSpec[];
};

export type SuigarNft = {
	id: string;
	name: string;
	description: string;
	url: string;
};

const TRADEPORT_SUIGAR_CANE_URL = 'https://www.tradeport.xyz/sui/collection/0x611e724cbd74e740ab0ae4fbbf1b57f44d9e75be7d0135704ad86eab7e518a12';

export function mapToSuigarNft(raw: any): SuigarNft {
	const {
		id: { id },
		name,
		description,
		url,
	} = raw.data.content.fields;
	return { id, name, description, url: mapToUrl(url) };
}

export function mapToNftFactory(raw: any): NftFactory {
	const {
		id: { id },
		specs,
	} = raw.content.fields;
	return { id, specs: specs.fields.contents.map(mapToNftSpec) };
}

export function mapToNftSpec(raw: any): NftSpec {
	const valueFields = raw.fields.value.fields;
	const {
		id: { id },
		name,
		description,
		url,
		supply,
		available,
		price,
	} = valueFields;
	const releaseRaw =
		valueFields.release_timestamp ??
		valueFields.release_ts ??
		valueFields.release_ms ??
		valueFields.release_time ??
		valueFields.release_at ??
		valueFields.release;

	let customDescription;
	let secondaryMarketUrl: string | undefined;
	switch (name) {
		case 'Suigar Cane':
			customDescription =
				'Crafted from the first crystals gathered by Suifrens at the dawn of the Suigar universe, the Suigar Cane contains an unusually high concentration of sugar!';
			secondaryMarketUrl = TRADEPORT_SUIGAR_CANE_URL;
			break;
		case 'Slush Candy':
			secondaryMarketUrl = TRADEPORT_SUIGAR_CANE_URL;
			break;
	}

	return {
		id,
		name,
		description,
		customDescription,
		secondaryMarketUrl,
		url: mapToUrl(url),
		supply,
		available: parseInt(available),
		price,
	};
}

function mapToUrl(url: string) {
	return url.replace('ipfs://', 'https://ipfs-ops-api.rep.run/ipfs/');
}

export function mapToLootboxes(raw: any): Lootboxes {
	const {
		content: {
			fields: {
				id: { id },
				lootboxes,
			},
		},
	} = raw;
	return {
		id,
		lootboxes: lootboxes.fields.contents.reverse().map(mapToLootbox),
	};
}

export function mapToLootbox(raw: any): Lootbox {
	const {
		available,
		id: { id },
		listed,
		price,
		title,
		total_supply: totalSupply,
	} = raw.fields.value.fields;
	return { id, title, price, listed, totalSupply, available };
}

export function mapToPurchasedLootbox(raw: any, suigar: Lootboxes): PurchasedLootbox {
	const {
		data: {
			content: {
				fields: {
					id: { id },
					lootbox_id: lootboxId,
				},
			},
		},
	} = raw;

	return { id, lootboxId, data: suigar.lootboxes[lootboxId] };
}
